window.addEventListener("turbolinks:load", () => {    
    const links = document.querySelectorAll("div.show_hide_password");

    if (links != null) {
        //
        // Password show hide when available
        //
        if ($('input.show_hide_password')) {
            $('#icon_eye').hide()
            $('#icon_eye_slash').show()
            links.forEach((element) => {
                element.addEventListener("click", (event) => {
                    if($('input.show_hide_password').attr("type") == "text") {
                        $('input.show_hide_password').attr('type', 'password');
                        $('#icon_eye').toggle();
                        $('#icon_eye_slash').toggle();
                    } else if($('input.show_hide_password').attr("type") == "password") {
                        $('input.show_hide_password').attr('type', 'text');
                        $('#icon_eye').toggle();
                        $('#icon_eye_slash').toggle();
                    }
                });
            });
        };
    }
})
